import qs from 'qs';
import { FormattedMessage, useIntl } from 'react-intl';

import { AutoDismissFlag } from '@atlaskit/flag';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import { token } from '@atlaskit/tokens';

import { ComponentFlagId, HandleDismissedType } from 'src/redux/flags/types';

import { messages } from './delete-repository.i18n';

type Props = {
  id: ComponentFlagId;
  description: string;
} & HandleDismissedType;

const DeleteRepositorySuccessFlag = ({
  id,
  description,
  ...otherProps
}: Props): JSX.Element => {
  const intl = useIntl();
  const query = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  return (
    <AutoDismissFlag
      {...otherProps}
      id={id}
      description={
        query.repo_name ? (
          <FormattedMessage
            {...messages.deleteMessageDescription}
            values={{
              repoName: `${query.repo_name}`,
              bold: chunks => <strong>{chunks}</strong>,
            }}
          />
        ) : (
          <FormattedMessage {...messages.deleteUnknownRepoDescription} />
        )
      }
      icon={
        <CheckCircleIcon
          spacing="spacious"
          label="Success"
          color={token('color.icon.success')}
        />
      }
      title={intl.formatMessage(messages.deleteMessageSuccessTitle)}
    />
  );
};

// eslint-disable-next-line import/no-default-export
export default DeleteRepositorySuccessFlag;
